import React from "react";
import { Link, useLocation } from "react-router-dom";
import Auth from "../../utils/auth";

const Header = (props) => {
  const location = useLocation();
  let breadCrumb;
  let propsLoc = location.pathname.toLowerCase();
  if (propsLoc.indexOf("/kycs") === 0) {
    let lastVal = [
      { key: "customer", value: "Customer" },
      { key: "contacts", value: "Contacts" },
      { key: "banks", value: "Banks" },
      { key: "addresses", value: "Addresses" },
      { key: "businessentity", value: "Business Entity" },
      { key: "taxids", value: "Tax Ids" },
      { key: "accountanalysis", value: "Account Analysis" },
      { key: "transactionanalysis", value: "Transaction Analysis" },
      { key: "miscellaneouscustomer", value: "Customer Miscellaneous" },
      { key: "supplieranalysis", value: "Supplier Analysis" },
    ];
    let propsArr = propsLoc.split("/");
    let breadcrumb = [];
    for (let i = 1; i < propsArr.length; i++) {
      if (i === 1) {
        breadcrumb.push("KYCS");
      // } else if (i === 2) {
      //   breadcrumb.push(location.state);
      } else if (i === 4) {
        let val = lastVal
          .filter((f) => {
            return f.key === propsArr[i];
          })
          .map((m) => {
            return m.value;
          });
        breadcrumb.push(val);
      } else {
        breadcrumb.push(
          propsArr[i].charAt(0).toUpperCase() + propsArr[i].slice(1)
        );
      }
    }
    breadCrumb = breadcrumb.join(" > ");
  } else if (propsLoc.indexOf("/kyc") === 0) {
    let lastVal = [
      { key: "customer", value: "Customer" },
      { key: "contacts", value: "Contacts" },
      { key: "banks", value: "Banks" },
      { key: "addresses", value: "Addresses" },
      { key: "businessentity", value: "Business Entity" },
    ];
    let propsArr = propsLoc.split("/");
    let breadcrumb = [];
    for (let i = 1; i < propsArr.length; i++) {
      if (i === 1) {
        breadcrumb.push("KYC");
      } else {
        let val = lastVal
          .filter((f) => {
            return f.key === propsArr[i];
          })
          .map((m) => {
            return m.value;
          });
        breadcrumb.push(val);
      }
    }
    breadCrumb = breadcrumb.join(" > ");
  } else {
    let routes = [
      { path: "/downloads", breadcrumb: "Downloads" },
      { path: "/searchclient", breadcrumb: "Search Client" },
      { path: "/changecustomersupplier", breadcrumb: "Change Client Type" },
      { path: "/accessrights", breadcrumb: "Access Rights" },
      { path: "/admincreateuser", breadcrumb: "Manage User(s)" },
      { path: "/query", breadcrumb: "Query" },
      { path: "/queries", breadcrumb: "Queries" },
      { path: "/kycstatus", breadcrumb: "KYC Status" },
      { path: "/searchUsers", breadcrumb: "Registration Correction" },
      { path: "/locationWise", breadcrumb: "Location-wise Registration" },
    ];
    breadCrumb = routes
      .filter((f) => {
        return f.path === propsLoc;
      })
      .map((m) => {
        return m.breadcrumb;
      });
  }
  let sideBarToggler = (e) => {
    e.preventDefault();
    let bodyElements = document.getElementsByTagName("body");
    if (bodyElements && bodyElements[0]) {
      let body = bodyElements[0];
      if (body.classList.contains("sidebar-lg-show")) {
        body.classList.remove("sidebar-lg-show");
      } else {
        body.classList.add("sidebar-lg-show");
      }
    }
  };
  return (
    <React.Fragment>
      <header className="app-header navbar">
        <a className="navbar-brand">
          <img
            width="125"
            height="25"
            className="navbar-brand-full"
            alt="Ameya"
            src="/images/logo.jpg"
          />
        </a>

        {/* for large screen - from 991px  */}
        <a
          className="d-none d-sm-block sideBarToggleIcon"
          onClick={(e) => sideBarToggler(e)}
        >
          <i className="fa fa-bars"></i>
        </a>

        <span
          className="d-none d-md-block"
          style={{ color: "#f8f9fa", fontSize: "15px" }}
        >
          {breadCrumb}
        </span>

        <ul className="nav navbar-nav ml-auto">
          {/* for small screen - 3???  till 575px */}
          <a
            className="d-block d-sm-none sideBarToggleIcon"
            onClick={(e) => sideBarToggler(e)}
          >
            <i className="fa fa-bars"></i>
          </a>

          <span className="d-none d-sm-block " style={{ color: "#fff" }}>
            <i>Welcome, {Auth.get("name")}</i>
          </span>

          <span className=" d-xs-block d-sm-none" style={{ color: "#fff" }}>
            <i> {Auth.get("name")}</i>
          </span>

          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle "
              role="button"
              aria-expanded="false"
              aria-haspopup="true"
              data-toggle="dropdown"
            >
              <i className="fa fa-user user-menu-link"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right dropdown-menu-lg">
              <Link to={"/ChangePassword"} className="dropdown-item">
                <i className="fa fa-key"></i> &nbsp; Change Password{" "}
              </Link>
            </div>
          </li>
        </ul>

        <Link className="" to="/Logout">
          <span className="logout">
            <i className="fa fa-power-off"></i>
          </span>
        </Link>
      </header>
    </React.Fragment>
  );
};
export default Header;
